
import './assessmentSkeleton.css';

const AssessmentSkeleton = () => {
    return (
        <>
        <div className='assessment-skeleton-wrapper'>
            <div className="skeleton-card">
            <div className="skeleton-title"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
        </div>
        <div className="skeleton-card">
            <div className="skeleton-title"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
        </div>
        <div className="skeleton-card">
            <div className="skeleton-title"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-checkbox"></div>
        </div>
        </div>
        
        </>
    );
};

export default AssessmentSkeleton;